import { createFileRoute } from '@tanstack/react-router'
import { PlaceOrder } from '~/features/installations/components/PlaceOrder'

export const Route = createFileRoute('/orders/new')({
  component: PlaceOrder
})
